import React from 'react';
import './TicketDetailsModal.scss';
import moment from 'moment/moment';
import DefaultModal from '../defaultModal/DefaultModal';
import TicketRideInfo from './components/TicketRideInfo';
import useTranslation from '../../../../hooks/translation/useTranslation';
import isIosWebview from '../../../../../utils/functions/isIosWebview';
import { getTicketPassService } from '../../../../../services/customer/ticketServices';

const paragraphClass = 'text-sm m-0';
const titleParagraphClass = `${paragraphClass} font-bold`;
const descriptionParagraphClass = `${paragraphClass} text-gray-gr truncate`;
const refundedClass = 'text-primary font-bold';
function TicketDetailsModal({
  detailsModal,
  setDetailsModal,
  handleAdditionalServices,
  handleTicketRefund,
  expired = false,
}) {
  const { data, show } = detailsModal;
  const isExpired = moment().isAfter(data[0]?.departure_date);
  const { trans } = useTranslation();

  const handleClose = () => {
    setDetailsModal({
      show: false,
      data: [],
    });
  };

  const handleDownloadPass = async (id) => {
    if (window?.ReactNativeWebView) {
      const ticketPass = await getTicketPassService(id);
      if (ticketPass?.base64) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'addToWallet', data: ticketPass?.base64 }));
      }
    }
  };
  return (
    <DefaultModal
      show={show}
      setShow={handleClose}
      className={`ticket-details-modal ${isExpired ? 'expired-ticket' : 'active-ticket'}`}
      zIndex={9999}
    >
      <div className="flex flex-col gap-5">
        <TicketRideInfo data={data} isExpired={isExpired} />
        <div className="w-full h-[1px] bg-black" />
        {
          data?.map((ticket, index) => {
            const isRefunded = ticket?.is_refunded;
            const paragraphClassWithRefund = isRefunded ? `${descriptionParagraphClass} ${refundedClass}` : descriptionParagraphClass;
            return (
              <React.Fragment key={ticket?.id}>
                <div className="flex flex-col gap-3">
                  <div className="grid grid-cols-2">
                    <p className={`${titleParagraphClass}`}>
                      {trans('passenger')}
                      {' '}
                      {index + 1}
                    </p>
                    <p className={`${titleParagraphClass} flex-[1]`}>
                      {trans('document_number')}
                    </p>
                  </div>
                  <div className="grid grid-cols-2">
                    <p className={`${paragraphClassWithRefund}`}>{ticket?.passenger}</p>
                    <p className={`${paragraphClassWithRefund}`}>{ticket?.document_code}</p>
                  </div>
                  <div className="grid grid-cols-2">
                    <p className={`${titleParagraphClass}`}>
                      {trans('wagon')}
                    </p>
                    <p className={`${titleParagraphClass}`}>
                      {trans('seat')}
                    </p>
                  </div>
                  <div className="grid grid-cols-2">
                    <p className={`${paragraphClassWithRefund}`}>{ticket?.wagon_number}</p>
                    <p className={`${paragraphClassWithRefund}`}>{ticket?.seat_number}</p>
                  </div>
                  {!expired && (
                  <div className="grid grid-cols-2">
                    <p className={`${titleParagraphClass}`}>
                      {trans('additional_services')}
                    </p>
                    <p className={`${titleParagraphClass}`}>
                      {trans('refund')}
                    </p>
                  </div>
                  )}
                  <div className="grid grid-cols-2">
                    {!expired && (
                    <button
                      type="button"
                      className="bg-transparent border-none flex gap-2 p-0 items-center"
                      onClick={() => {
                        handleClose();
                        handleAdditionalServices(ticket);
                      }}
                    >
                      {trans('see/add')}
                    </button>
                    )}
                    <button
                      type="button"
                      className="bg-transparent border-none flex gap-2 p-0 items-center"
                      onClick={() => {
                        handleClose();
                        handleTicketRefund(ticket, data);
                      }}
                    >
                      {!ticket?.is_refunded && <div className="cross" />}
                      {trans(
                        ticket?.is_refunded
                          ? 'refunded'
                          : 'refund',
                      )}
                    </button>
                  </div>
                  {!expired
                      && window.ReactNativeWebView
                      && isIosWebview()
                      && (
                      <button
                        type="button"
                        className="bg-transparent border-none w-fit"
                        onClick={
                                () => {
                                  handleDownloadPass(ticket?.id);
                                }
                              }
                      >
                        <img
                          src="/ticketLogos/addToWallet.png"
                          alt="addToWallet"
                          width={120}
                        />
                      </button>
                      )}
                </div>
                <div className="w-full h-[1px] bg-black" />
              </React.Fragment>
            );
          })
        }
        <div className="flex flex-col gap-2 items-center">
          <p className={titleParagraphClass}>
            {trans('price')}
          </p>
          <p className={titleParagraphClass}>
            {data?.reduce((acc, cur) => acc + cur.price, 0)}
            {trans('gel')}
          </p>
        </div>
      </div>
    </DefaultModal>
  );
}

export default TicketDetailsModal;
